/**
 * Fundamentals's keys
 */
export const StorageFundamentals = {
  instruments: 'instruments',
  positions: 'positions',
  genres: 'genres',
  cities: 'cities',
};
